import { Reveal, SectionHeading } from "@/components/Reveal";
import { CONTACT } from "@/lib/site";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-6">
          <SectionHeading
            overline="About LooXury"
            title={
              <>
                Hospitality, down to the <span className="italic bronze-text">last detail</span>
              </>
            }
          />
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-6 text-base font-light leading-relaxed text-stone-600 md:text-lg">
              <p>
                LooXury Rentals was born from a simple observation: the most carefully planned events in Simcoe
                County were being let down by their facilities. Couples spent months on flowers and table settings —
                then pointed their guests toward a plastic portable toilet.
              </p>
              <p>
                We set out to change that. Our restroom trailers are appointed like boutique hotel powder rooms —
                champagne bronze fixtures, warm lighting, climate control, and running water — delivered, placed,
                and detailed by a team that treats your event like its own.
              </p>
              <p>
                From lakeside weddings and vineyard corporate retreats to festivals, construction sites, and film &amp;
                TV production sets, we bring five-star comfort wherever people gather.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-x-12 gap-y-6 border-t border-stone-200 pt-8" data-testid="about-facts">
              <div>
                <p className="font-serif text-3xl font-light text-stone-900">Simcoe Country</p>
                <p className="mt-1 text-xs font-semibold tracking-[0.2em] uppercase text-brand-bronze-dark">Born &amp; based</p>
              </div>
              <div>
                <p className="font-serif text-3xl font-light text-stone-900">6</p>
                <p className="mt-1 text-xs font-semibold tracking-[0.2em] uppercase text-brand-bronze-dark">Occasions we serve</p>
              </div>
              <div>
                <p className="font-serif text-3xl font-light text-stone-900">1</p>
                <p className="mt-1 text-xs font-semibold tracking-[0.2em] uppercase text-brand-bronze-dark">Standard: flawless</p>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.15}>
            <div className="gallery-frame group">
              <div className="overflow-hidden">
                <img
                  src="/images/gallery-evening.png"
                  alt="A LooXury trailer glowing warmly at an evening gala"
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  data-testid="about-image"
                />
              </div>
            </div>
            <p className="mt-4 text-xs tracking-wide text-stone-400">
              Delivered from {CONTACT.address}, serving {CONTACT.region}.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
